import React from "react";
import "./Service.scss";

// Components
import LandingBanner from "components/LandingBanner/LandingBanner";
import DynamicImage from "components/DynamicImage/DynamicImage";

// Libraries & Packages
import { Link } from "react-router-dom";

// Utils
import AnimatedText from "components/Headings/Common/Utils/Animation/AnimatedText";
import Text from "components/Headings/Text/Text";
import { getServiceResources } from "../ServiceResourecesUtils";

function Service({ serviceData, serviceTitle = "Logo Design" }) {
  const { data, loading } = serviceData;
  const serviceResourses = getServiceResources(serviceTitle);

  return (
    <div className="service">
      <div className="service__baner">
        <LandingBanner title={serviceTitle} banner={serviceResourses.banner} />
      </div>
      <div className="service__grid">
        {!loading &&
          data
            .sort((a, b) => {
              return new Date(b.fields.date) - new Date(a.fields.date);
            })
            .map((item, i) => {
              return (
                <div className="service__card" key={i}>
                  <div className="service__card__image">
                    <Link to={`/service/${item.fields.slug}`}>
                      <DynamicImage
                        image={`https:${item.fields.thumbnail.fields.file.url}`}
                      />
                    </Link>
                  </div>
                  <div className="service__card__title">
                    <AnimatedText>{item.fields.title}</AnimatedText>
                  </div>
                  <div className="service__card__description">
                    <Text>
                      <AnimatedText>{item.fields.description}</AnimatedText>
                    </Text>
                  </div>
                </div>
              );
            })}
      </div>
      {data.length === 0 && (
        <div className="service__fallback">
          <Text>
            <AnimatedText>
              This section will be updated soon. Stay tuned!
            </AnimatedText>
          </Text>
        </div>
      )}
    </div>
  );
}

export default Service;
